import { render, staticRenderFns } from "./Form_Label.vue?vue&type=template&id=53db25d4&"
import script from "./Form_Label.vue?vue&type=script&lang=js&"
export * from "./Form_Label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports